import { Component } from "react";
import Button from "@material-ui/core/Button";
import JSONTree from "react-json-tree";

class SystemInitComponent extends Component {
  interval = false;

  componentDidMount() {
    this.props.getInitStatus();

    this.interval = setInterval(() => {
      this.props.getInitStatus();
      this.props.getResetStatus();
    }, 20000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.interval = false;
  }

  render() {
    return (
      <div>
        <h3>System init</h3>{" "}
        <Button
          variant="contained"
          color="primary"
          onClick={this.props.initSystem}
        >
          {" "}
          Init system
        </Button>
        <hr />
        <h3>System reset</h3>{" "}
        <Button
          variant="contained"
          color="primary"
          onClick={this.props.resetSystem}
        >
          {" "}
          Init reset
        </Button>
        <hr />
        {this.props.browser.initStatus.fetched ? (
          <div className="init-status">
            <br />
            init status <br />
            <JSONTree
              hideRoot={true}
              data={this.props.browser.initStatus.data}
            />
            <hr />
            <br />
            reset status <br />
            <JSONTree
              hideRoot={true}
              data={this.props.browser.resetStatus.data}
            />
            {/*Overall progress: {this.props.browser.initStatus.data.Progress * 100} % <br/>
                        Projection synch status: {synchStatusEnum[this.props.browser.initStatus.data.ProjectionSynchStatus]} <br/>
                        System init status: {synchStatusEnum[this.props.browser.initStatus.data.SystemInitStatus]} <br/>
                        <h4> Sub tasks </h4>
                        {
                            Object.keys(this.props.browser.initStatus.data.SubTasks).map( (key, index) => {
                                return (
                                    <div className="init-status-sub" key={index}>
                                        Key: {key} <br/>
                                        Status: {synchStatusEnum[this.props.browser.initStatus.data.SubTasks[key].Status]} <hr/>
                                        {
                                            this.props.browser.initStatus.data.SubTasks[key].Errors.map( (error, index) => {
                                                return (
                                                    <div className="init-status-errors" key={index}>
                                                        Error: {error} <hr/>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                        }
                        <h4> General Errors </h4>
                        {
                            this.props.browser.initStatus.data.Errors.map( (error, index) => {
                                return (
                                    <div className="init-status-errors" key={index}>
                                        Error: {error} <hr/>
                                    </div>
                                )
                            })
                        }*/}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}
export default SystemInitComponent;
